import { render, staticRenderFns } from "./BoardCardLocation.vue?vue&type=template&id=103b5b47&"
import script from "./BoardCardLocation.vue?vue&type=script&lang=js&"
export * from "./BoardCardLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports